import { Box, Typography, Grid, Table, TableBody, TableRow, TableCell, Chip, useTheme } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import RouterIcon from '@mui/icons-material/Router';
import FactoryIcon from '@mui/icons-material/Factory';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

interface LockerInfoProps {
  data: {
    name: string;
    is_available: boolean;
    roomName?: string;
    port?: string;
    equipmentName?: string;
    manufacturerName?: string;
    tenantName?: string;
  };
}

export function LockerInfo({ data }: LockerInfoProps) {
  const theme = useTheme();

  return (
    <>
      <Typography fontWeight={700} fontSize={18} color={theme.palette.text.primary} mb={3} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <LockIcon sx={{ color: theme.palette.primary.main, fontSize: 22 }} /> Informações do Armário
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.secondary, width: 140, border: 'none' }}>
                  Nome
                </TableCell>
                <TableCell sx={{ fontWeight: 500, color: theme.palette.text.primary, border: 'none' }}>
                  {data.name}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.secondary, border: 'none' }}>
                  Status
                </TableCell>
                <TableCell sx={{ fontWeight: 500, color: theme.palette.text.primary, border: 'none' }}>
                  <Chip
                    icon={data.is_available ? <CheckCircleIcon sx={{ fontSize: '16px !important' }} /> : <CancelIcon sx={{ fontSize: '16px !important' }} />}
                    label={data.is_available ? 'Disponível' : 'Indisponível'}
                    color={data.is_available ? 'success' : 'error'}
                    size="small"
                    variant="outlined"
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.secondary, border: 'none' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <MeetingRoomIcon sx={{ fontSize: 16 }} />
                    Área
                  </Box>
                </TableCell>
                <TableCell sx={{ fontWeight: 500, color: theme.palette.text.primary, border: 'none' }}>
                  {data.roomName || '-'}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.secondary, border: 'none' }}>
                  Porta
                </TableCell>
                <TableCell sx={{ fontWeight: 500, color: theme.palette.text.primary, border: 'none' }}>
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: 'monospace',
                      backgroundColor: '#F3F4F6',
                      color: '#111827',
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                      fontSize: 13
                    }}
                  >
                    {data.port}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>

        <Grid item xs={12} md={6}>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.secondary, width: 140, border: 'none' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <RouterIcon sx={{ fontSize: 16 }} />
                    Equipamento
                  </Box>
                </TableCell>
                <TableCell sx={{ fontWeight: 500, color: theme.palette.text.primary, border: 'none' }}>
                  {data.equipmentName || '-'}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.secondary, border: 'none' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <FactoryIcon sx={{ fontSize: 16 }} />
                    Fabricante
                  </Box>
                </TableCell>
                <TableCell sx={{ fontWeight: 500, color: theme.palette.text.primary, border: 'none' }}>
                  {data.manufacturerName || '-'}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.secondary, border: 'none' }}>
                  Empresa
                </TableCell>
                <TableCell sx={{ fontWeight: 500, color: theme.palette.text.primary, border: 'none' }}>
                  {data.tenantName || '-'}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </>
  );
} 